import { render, staticRenderFns } from "./test.vue?vue&type=template&id=f2cb0748&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "./test.vue?vue&type=style&index=0&id=f2cb0748&lang=less&scoped=true&"
import style1 from "./test.vue?vue&type=style&index=1&id=f2cb0748&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cb0748",
  null
  
)

export default component.exports